import { ChangeEvent } from 'react'

const dateFormater = (input: HTMLInputElement) => {
  const value = input.value.replace(/\D/g, '')

  if (value.length < 3) return (input.value = value)

  if (value.length < 5)
    return (input.value = `${value.slice(0, 2)}/${value.slice(2)}`)
  if (value.length < 12)
    return (input.value = `${value.slice(0, 2)}/${value.slice(2, 4)}/${value.slice(4, 8)}`)

  return (input.value = '')
}

export const dateMask = (event: ChangeEvent<HTMLInputElement>) => {
  if (event.target instanceof HTMLInputElement) {
    dateFormater(event.target)
  }
}
